import {
  INSTAGRAM,
  LOYALTY_PROGRAM_SENDOUTS,
  MAX_MESSENGER,
  TELEGRAM,
  TELEGRAM_PERSONAL,
  VK,
} from '@app/constants/socialIntegrationsTypes';

/**
 * Подписи каналов для блока аккаунтов клиента. Свой словарь, а не
 * INTEGRATIONS_DICTIONARY: здесь короткие названия под узкую колонку,
 * они уходят в подсказку и placeholder вместо текстового лейбла.
 */
export const SOCIAL_LABELS: Record<string, string> = {
  [INSTAGRAM]: 'Instagram',
  [MAX_MESSENGER]: 'Max',
  [TELEGRAM]: 'Telegram Bot',
  [TELEGRAM_PERSONAL]: 'Telegram',
  [VK]: 'VK',
  [LOYALTY_PROGRAM_SENDOUTS]: 'Рекомендуй',
};
